/**
 *
 * @author      Jeff Adams <jeff@tinyfly.com>
 * @copyright   Traxo, Inc. 2020
 */

import { TravelApi } from '@/services/api-travel.js';

/**
 * Local state data
 * -----------------------------------------------------
 */
export const state = getDefaultState();

/**
 * Computed properties of the local state
 * -----------------------------------------------------
 */
export const getters = {
  all: (state) => state.all.data || [],
  pagination: (state) => state.all.meta || {},
  geoData: (state, getters) => {
    const geoJSON = {
      type: 'FeatureCollection',
      features: [],
    };

    getters.all.forEach((item) => {
      if (item.lon && item.lat) {
        geoJSON.features.push({
          type: 'Feature',
          geometry: {
            type: 'Point',
            coordinates: [Number(item.lon), Number(item.lat)],
          },
          properties: {
            ...item,
            // move member to top-level member prop
            member: item.included.find((data) => data.type === 'member'),
          },
        });
      }
    });

    return geoJSON;
  },
};

/**
 * Synchronous changes to the local state
 * -----------------------------------------------------
 */
export const mutations = {
  SET_TRAVEL(state, travel) {
    state.all = travel;
  },
};

/**
 * Async CRUD actions against the api
 * -----------------------------------------------------
 */
const endpoints = {
  all: 'allIndex',
  trip: 'tripIndex',
  air: 'flightIndex',
  hotel: 'hotelIndex',
  car: 'carIndex',
  rail: 'railIndex',
  transportation: 'transportationIndex',
  restaurant: 'restaurantIndex',
  activity: 'activityIndex',
};

export const actions = {
  index({ commit }, { query = {} }) {
    const types = query?.type?.split(',');
    const endpoint = types?.length === 1 ? endpoints[types[0]] : endpoints['all'];

    return TravelApi[endpoint](query)
      .then((trips) => {
        commit('SET_TRAVEL', trips);
        return trips;
      })
      .catch((error) => {
        if (error.message !== 'canceled') {
          throw error;
        }
      });
  },
};

function getDefaultState() {
  return {
    all: [],
  };
}
